<template>
  <canvas></canvas>
</template>

<script>
import canvasUtils from './modules/canvasUtils.js';
import timelineCanvas from './mixins/timelineCanvas.js';
import TimelineMarker from '../../../modules/TimelineMarker.js';
import Color from '../../../modules/Color.js';
import TimeValue from '../../../modules/TimeValue.js';

const markerAreaOverlayColor = new Color(0, 0, 0, 0.05);
const markerBeginColor = new Color(20, 116, 30);
const markerEndColor = new Color(10, 40, 142);

export default {
  mixins: [
    timelineCanvas,
  ],

  watch: {
    timelineViewBegin: {
      handler() { this.$_setDirty(true) },
      deep: true,
    },
    timelineViewEnd: {
      handler() { this.$_setDirty(true) },
      deep: true,
    },
    timelineMarker: {
      handler() { this.$_setDirty(true) },
      deep: true,
    },
  },

  props: {
    timelineViewBegin:    { type: TimeValue },
    timelineViewEnd:      { type: TimeValue },
    timelineViewDuration: { type: TimeValue },
    timelineMarker:       { type: TimelineMarker },
  },

  inject: [
    'scaledTimeToPx',
  ],

  methods: {
    /* public */
    draw() {
      this.$_draw(() => {
        if (this.timelineMarker !== undefined) {
          drawMarker.call(this, this.timelineMarker);
        }
      });

      function drawBar(timeOffsetPx, color) {
        let timelineForegroundCanvas = this.$data.$_timelineCanvasContext;
        canvasUtils.drawLine(
          timelineForegroundCanvas,
          { x: timeOffsetPx, y: 0 },
          { y: this.$data.$_timelineCanvasHeightPx },
          { lineWidth: 1, strokeStyle: color, lineDash: [] },
        );
      }

      function drawMarker(timelineMarker) {
        {
          let markerBeginTime = timelineMarker.begin;
          let markerEndTime = timelineMarker.end;
          if ((markerBeginTime !== null) && markerBeginTime.isGreaterThanOrEqualTo(this.timelineViewEnd)) return;
          if ((markerEndTime !== null) && markerEndTime.isLessThan(this.timelineViewBegin)) return;

          let markerAreaBeginTimeOffsetPx = undefined;
          if (markerBeginTime === null) {
            markerAreaBeginTimeOffsetPx = 0;
          } else {
            let isMarkerBeginInTimelineView = markerBeginTime.isGreaterThanOrEqualTo(this.timelineViewBegin);
            if (isMarkerBeginInTimelineView) {
              let markerBeginTimeOffset = markerBeginTime.getOffsetFrom(this.timelineViewBegin);
              let markerBeginTimeOffsetPx = this.scaledTimeToPx(markerBeginTimeOffset);
              drawBar.call(this, markerBeginTimeOffsetPx, markerBeginColor.styleString);
              markerAreaBeginTimeOffsetPx = this.scaledTimeToPx(markerBeginTimeOffset);
            } else {
              markerAreaBeginTimeOffsetPx = this.scaledTimeToPx(TimeValue.zero);
            }
          }

          let markerAreaEndTimeOffsetPx = undefined;
          if (markerEndTime === null) {
            markerAreaEndTimeOffsetPx = this.scaledTimeToPx(this.timelineViewDuration);
          } else {
            let isMarkerEndInTimelineView = markerEndTime.isLessThanOrEqualTo(this.timelineViewEnd);
            if (isMarkerEndInTimelineView) {
              let markerEndTimeOffset = markerEndTime.getOffsetFrom(this.timelineViewBegin);
              let markerEndTimeOffsetPx = this.scaledTimeToPx(markerEndTimeOffset);
              drawBar.call(this, markerEndTimeOffsetPx, markerEndColor.styleString);
              markerAreaEndTimeOffsetPx = this.scaledTimeToPx(markerEndTimeOffset);
            } else {
              markerAreaEndTimeOffsetPx = this.scaledTimeToPx(this.timelineViewDuration);
            }
          }

          let markerAreaDurationPx = markerAreaEndTimeOffsetPx - markerAreaBeginTimeOffsetPx;
          drawMarkerArea.call(this, markerAreaBeginTimeOffsetPx, markerAreaDurationPx);
        }

        function drawMarkerArea(markerAreaBeginTimeOffsetPx, markerAreaDurationPx) {
          canvasUtils.drawRect(
            this.$data.$_timelineCanvasContext,
            {
              x: markerAreaBeginTimeOffsetPx,
              width: markerAreaDurationPx,
              height: this.$data.$_timelineCanvasHeightPx,
            },
            {
              fill: true,
              fillStyle: markerAreaOverlayColor.styleString,
            },
          );
        }
      }
    },
  }
};
</script>
